"use client"

import Button from "@/components/ui/Button"
import { ReactNode } from "react"

type ButtonItem = {
   label: string
   href: string
   icon?: ReactNode
   external?: boolean
   className?: string
   style?: React.CSSProperties
}

interface Props {
   buttons: ButtonItem[]
}

export const ButtonSection = ({ buttons }: Props) => {
   return (
      <div className="mt-4 flex flex-col gap-3 sm:flex-row sm:flex-wrap">
         {buttons.map((btn, i) => (
            <Button
               key={i}
               size="md"
               className={`flex w-full items-center justify-center gap-2 rounded-xl sm:w-auto ${btn.className}`}
               style={btn.style}
               onClick={() => {
                  if (btn.external) {
                     window.open(btn.href, "_blank", "noopener,noreferrer")
                  } else {
                     window.location.href = btn.href
                  }
               }}
            >
               {btn.label}
               {btn.icon}
            </Button>
         ))}
      </div>
   )
}
